import React, { useEffect } from 'react';
import '../styles/TransXT.scss';


import LinearProgress from '@mui/material/LinearProgress';
import { useNavigate } from 'react-router-dom';

const APIBanking = `${process.env.REACT_APP_S3_URL}tranxtGroup.svg`;
const APIBankingMobile = `${process.env.REACT_APP_S3_URL}DiagramMobile.svg`;
const BAASImage = `${process.env.REACT_APP_S3_URL}transxtSecondImage.svg`;
const Arrow = `${process.env.REACT_APP_S3_URL}RIghtArrowBgWhite.svg`;

const TransXT: React.FC = () => {
    const navigate = useNavigate();
    const [apiProgress, setApiProgress] = React.useState(0);
    const [baasProgress, setBaasProgress] = React.useState(0);
    useEffect(() => {
        const timer = setInterval(() => {
            if(apiProgress === 100 && baasProgress === 100){
                setApiProgress(0);
                setBaasProgress(0);
            }
            if(apiProgress < 100) {
                setApiProgress(apiProgress + 1);
            } else if(baasProgress < 100){
                setBaasProgress(baasProgress + 1);
            }
        }, 50);

        return () => {
            clearInterval(timer);
          };
    }, [apiProgress, baasProgress])
    return (
        <section className="transxt-section">
            <div className='left-section'>
                <span>Introducing </span>
                <h2 
                style={{
                    background: 'linear-gradient(81.88deg, #E51A4B 0%, #E36F8A 107.04%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text', // For Firefox
                    color: 'transparent',
                  }}
                >TransXT</h2>
                <p>Your bank-in-a-box! TransXT is our plug-and-play API banking platform that enables businesses to smoothly launch and enrich their digital financial offerings.</p>
                <button onClick={() => {navigate('/TransXT')}} className="learn-more-button">
                    <div className='align-proper' style={{gap:12}}>
                        <span style={{textTransform:'capitalize'}}>
                            Know more
                        </span>
                        <img src={Arrow} alt='' />
                    </div>
                </button>
                <div className="progress-container">
                    <div className="progress">
                        <span className={apiProgress < 100 ? 'tag bold' : 'tag'}
                            onClick={() => {
                                setApiProgress(0);
                                setBaasProgress(0);
                            }}>API Banking</span>
                        <LinearProgress variant="determinate" value={apiProgress} style={{
                            borderRadius: 20,
                            color: '#DC697F',
                            width: '50px',
                        }}/>
                    </div>
                    <div className="progress">
                        <span className={apiProgress === 100 && baasProgress <= 100 ? 'tag bold' : 'tag'}
                         onClick={() => {
                            setApiProgress(100);
                            setBaasProgress(0);
                        }}>Banking as a Service</span>
                        <LinearProgress variant="determinate" value={baasProgress} style={{
                            borderRadius: 20,
                            color: '#DC697F',
                            width: '50px',
                        }}/>
                    </div>
                </div>
            </div>
            <div className="apibanking">
                {
                    apiProgress < 100 ?
                    <img src={APIBanking} alt='APIBanking' />
                    : <img src={BAASImage} alt='APIBanking' />
                }
            </div>
            <div className="apibanking-mobile">
                {
                    apiProgress < 100 ?
                    <img className='apibanking-mobile-img' src={APIBankingMobile} alt='APIBanking' />
                    : <img className='apibanking-mobile-img' src={BAASImage} alt='APIBanking' />
                }
            </div>
        </section>
    );
};

export default TransXT;
